import {
  Column,
  DataGrid,
  Editing,
  HeaderFilter,
  FilterRow,
} from "devextreme-react/data-grid";
import { gridDataSource } from "./TipoResidenciaService";
import { useDispatch } from "react-redux";
import { selectItem } from "../../store/modules/tipoResidencia/action";

export default function TipoResidenciaGrid({ successMessage, warningMessage }) {
  const dispatch = useDispatch();

  const applyFilterTypes = [
    {
      key: "auto",
      name: "Immediately",
    },
    {
      key: "onClick",
      name: "On Button Click",
    },
  ];
  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  function handleInsert(event) {
    successMessage("Cadastro feito com sucesso");
  }

  function handleInsertError(event) {
    const { newData } = event;
    const required = typeof newData.descricao !== "string";
    const length = !required ? newData.descricao.length > 50 : false;

    event.isValid = !required && !length;

    if (required) warningMessage("Informe o tipo de residencia");
    if (length) warningMessage("O limite de caracteres é de 50");
  }

  function handleRemove({ data }) {
    successMessage("Tipo de residencia deletada com sucesso");
  }

  function handleUpdate(event) {
    successMessage("Alteração feita com sucesso");
  }

  function handleUpdating({ oldData, newData }) {
    dispatch(
      selectItem({
        ...oldData,
        ...newData,
      })
    );
  }

  return (
    <>
      <DataGrid
        dataSource={gridDataSource}
        remoteOperations={true}
        showBorders={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        onRowInserted={handleInsert}
        onRowRemoved={handleRemove}
        onRowUpdated={handleUpdate}
        onRowUpdating={handleUpdating}
        onRowValidating={handleInsertError}
      >
        <Editing mode="row" allowAdding allowDeleting allowUpdating useIcons />
        <FilterRow
          visible={filterOptions.showFilterRow}
          applyFilter={filterOptions.currentFilter}
        />
        <HeaderFilter />

        <Column dataField="descricao" filterOperations={false}>
          <HeaderFilter groupInterval={100} />
        </Column>
      </DataGrid>
    </>
  );
}
